const SHARE_CODE_PATTERN = /^[ABCDEFGHJKLMNPQRSTUVWXYZ23456789]{5}$/

/** Pasted codes often carry spaces or dashes; the wire form is five upper-case characters. */
export function normalizeShareCode(raw: string): string {
  return raw.replace(/[\s-]/g, '').toUpperCase()
}

export function isValidShareCode(code: string): boolean {
  return SHARE_CODE_PATTERN.test(code)
}
